import { Resource } from './resource';
import gql from 'graphql-tag';
import moment from 'moment';

export class HolidayResource extends Resource {
  public static async list() {
    const list = await this.query(
      {
        query: gql`
          query {
            holidays {
              group
              id
              name
              date
            }
          }
        `
      },
      'holidays'
    );
    return list.map((holiday: any) => {
      holiday.date = holiday.date ? moment(holiday.date) : undefined;
      return holiday;
    });
  }

  public static async add(name: string, color: string, type: number, startDate: Date, endDate: Date) {
    await this.mutation(
      {
        mutation: gql`
          mutation($name: String!, $color: String, $type: Int!, $startDate: DateTime!, $endDate: DateTime) {
            holidayCreate(startDate: $startDate, name: $name, type: $type, color: $color, endDate: $endDate)
          }
        `,
        variables: { name, color, type, startDate, endDate },
        refetchQueries: [
          {
            query: gql`
              query {
                holidays {
                  group
                  id
                  name
                  date
                }
              }
            `
          }
        ]
      },
      'holidayCreate'
    );
  }

  public static async delete(id: number) {
    await this.mutation({
      mutation: gql`
        mutation($id: Int!) {
          holidayDelete(id: $id) {
            id
          }
        }
      `,
      variables: { id },
      refetchQueries: [
        {
          query: gql`
            query {
              holidays {
                group
                id
                name
                date
              }
            }
          `
        }
      ]
    });
  }

  public static async deleteGroup(groupNumber: string) {
    await this.mutation({
      mutation: gql`
        mutation($groupNumber: String!) {
          holidayDeleteGroup(groupNumber: $groupNumber)
        }
      `,
      variables: { groupNumber },
      refetchQueries: [
        {
          query: gql`
            query {
              holidays {
                group
                id
                name
                date
              }
            }
          `
        }
      ]
    });
  }
}
